import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, DateRangePicker } from '@wit-support/ui';
import { cn } from './lib/cn.js';
/** Пресеты периода графиков «Контента». */
export const CONTENT_CHART_PRESETS = ['7d', '28d', '90d'];
export const CONTENT_CHART_PRESET_LABEL_RU = {
    '7d': '7 дней',
    '28d': '28 дней',
    '90d': '90 дней',
};
const pad = (n) => String(n).padStart(2, '0');
/** `YYYY-MM-DD` → локальная полночь (так её показывает календарь). */
export function calendarDayToDate(day) {
    const [y, m, d] = day.split('-').map(Number);
    return new Date(y, m - 1, d);
}
/** Дата календаря (локальные поля) → `YYYY-MM-DD`. */
export function dateToCalendarDay(d) {
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
/**
 * Период графиков: кнопки «7 / 28 / 90 дней» и свой диапазон дат. Свой
 * период применяется кнопкой «Применить» календаря; «Сбросить» возвращает 28 дней.
 */
export function ContentChartPeriodPicker({ value, onChange, className, }) {
    const range = value.kind === 'custom'
        ? { from: calendarDayToDate(value.from), to: calendarDayToDate(value.to) }
        : { from: undefined, to: undefined };
    // Календарь в режиме `confirm`: в `onChange` приходит только то, что
    // подтвердили «Применить» (оба конца) или «Сбросить» (пусто).
    const applyRange = (next) => {
        if (next.from && next.to) {
            onChange({
                kind: 'custom',
                from: dateToCalendarDay(next.from),
                to: dateToCalendarDay(next.to),
            });
        }
        else if (!next.from && !next.to) {
            onChange({ kind: 'preset', preset: '28d' });
        }
    };
    return (_jsxs("div", { role: "group", "aria-label": "\u041F\u0435\u0440\u0438\u043E\u0434", className: cn('flex flex-wrap items-center gap-2', className), children: [CONTENT_CHART_PRESETS.map((p) => {
                const active = value.kind === 'preset' && value.preset === p;
                return (_jsx(Button, { type: "button", size: "sm", variant: active ? 'primary' : 'secondary', "aria-pressed": active, onClick: () => onChange({ kind: 'preset', preset: p }), children: CONTENT_CHART_PRESET_LABEL_RU[p] }, p));
            }), _jsx(DateRangePicker, { value: range, onChange: applyRange, applyMode: "confirm", placeholder: "\u0421\u0432\u043E\u0439 \u043F\u0435\u0440\u0438\u043E\u0434", locale: "ru-RU", numberOfMonths: 1 })] }));
}
//# sourceMappingURL=content-overview-period.js.map